module.exports = __webpack_public_path__ + "static/media/mv.896b59cd.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mv.svg
// module id = 2165
// module chunks = 0